import RequestSender from '@/infrastructure/request-sender';
import { BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';
import { ThingClient } from '@studyportals/sp-thing-interface';

const thingUrl = webpackDefinitions.VUE_APP_THING_URL;
const thingClient = new ThingClient(new BaseSuperAgentRequestFactory(), RequestSender, thingUrl);

export default thingClient;
